import { render, staticRenderFns } from "./CortexIcon.vue?vue&type=template&id=2c98b7ee&"
import script from "./CortexIcon.vue?vue&type=script&lang=js&"
export * from "./CortexIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports